import { cacheFetch, deleteCached } from './cacheFetch.js';

import { credentialScope } from '../utils/credentialScope.js';

/**
 * Optional adapter for apiClient GET requests.
 * Reuses cacheFetch SWR semantics with the new apiClient contract.
 */
export const createCacheAdapter = (options = {}) => {
  const {
    key,
    staleMs = 60000,
    persist = false,
    storageKey,
    revalidate = true,
    credentialScoped = true,
    validateResponse,
  } = options;

  if (!key) {
    throw new Error('createCacheAdapter requires a cache key.');
  }

  return async ({ path, method, headers, token, signal, body, request }) => {
    if (method !== 'GET') {
      return request();
    }

    if (credentialScoped) deleteCached(key, { storageKey: storageKey || key });
    const authorization = Object.entries(headers || {}).find(([name]) => name.toLowerCase() === 'authorization')?.[1];
    const credential = typeof authorization === 'string' ? authorization.replace(/^Bearer\s+/i, '') : token;
    const result = await cacheFetch(path, {
      key: credentialScoped ? `${key}:auth:${credentialScope(credential)}` : key,
      method,
      body,
      headers,
      token,
      persist: credentialScoped ? false : persist,
      storageKey: credentialScoped ? undefined : storageKey,
      validateResponse,
      staleMs,
      revalidate,
      signal,
    });
    return credentialScoped ? structuredClone(result) : result;
  };
};

export default { createCacheAdapter };
